import { useQuery } from '@tanstack/react-query';

interface GtmConfig {
    gtmId: string;
    gtmHelperScriptUrl: string;
}

export const useGtmConfigQuery = (isEnabled?: boolean) => {
    return useQuery({
        queryKey: ['gtm-config'],
        queryFn: async (): Promise<GtmConfig> => {
            const response = await fetch(`${process.env.PUBLIC_URL}/gtm-config`);

            return (await response.json()) as GtmConfig;
        },
        enabled: isEnabled,
    });
};
